import { ITranslationConfig } from "../translation.config";

export class WebsiteTranslationConfig implements ITranslationConfig {
  public metrics: any;
  public labels: any;
  public reportTitles: any;
  public chartDimensions: any;
  public channels: any;
}
